import { lazy } from 'react';
import { PATHS_BY_KEY } from '@/hooks/useIsCurrentPage';

import { Config } from "@/config";

import rolesEnum from '@/constant/rolesEnum';
import { dynamicImport } from '@/helpers/new/dynamicImport';

//import EditClass from 'src/components/pages/Admin/NewStudents/Classes/components/EditClass';
const AdditionalProbeEdit = dynamicImport(
  () => import('@pages/Admin/AdditionalProbe/AdditionalProbeEdit'),
  'AdditionalProbeEdit',
)
// const AiTutor = lazy(() => import('@pages/Admin/AiTutor/AiTutor'))
// const AiTutorEdit = lazy(() => import('@pages/Admin/AiTutor/AiTutorEdit'))
const UsersRedirect = dynamicImport(
  () => import('@pages/Admin/AllUsers/UsersRedirect'),
  'UsersRedirect',
)
const HomeWorkPageContainer = lazy(() => import('@pages/HomeWork/HomeWorkPage.container'))
const PaymentForm = lazy(() => import('@pages/PaymentForm'))

const Departments = lazy(() => import('@pages/Admin/Departments'))
const Teams = lazy(() => import('@pages/Admin/Teams'))

const CollegesPage = lazy(()=>import('@pages/Admin/AllUsers/Colleges/CollegesPage'))
const StudentsPage = lazy(()=>import('@pages/Admin/AllUsers/Students/StudentsPage'))
const Parents = lazy(()=>import('@pages/Admin/AllUsers/Parents'))

const WrapperNewsViewing = lazy(() => import('@pages/NewsViewing'))
const News = lazy(() => import('@pages/Admin/News'))
const PreviewLesson = lazy(() => import('@pages/Admin/PreviewLesson'))
const GroupWrap = lazy(() => import('@pages/Admin/Reports/Group/GroupWrap'))
const GroupLessonReport = lazy(() => import('@pages/Admin/Reports/GroupReport'))
const GroupLessonpaymentReport = lazy(() => import('@pages/Admin/Reports/GroupLessonPayment'))
const CertificatesReport = lazy(() => import('@pages/Admin/Reports/Certificates'))
const PrivateLessonReport = lazy(() => import('@pages/Admin/Reports/PrivateReport'))
const IntroductoryLessonReport = lazy(() => import('@pages/Admin/Reports/IntroductoryLessonReport'))
const UserRatingReport = lazy(() => import('@pages/Admin/Reports/UserRatingReport'))
const ChatsStatisticsReport = lazy(() => import('@pages/Admin/Reports/ChatsStatistics'))
const Overview = lazy(() => import('@pages/Admin/Reports/Group/Overview'))
const PlatformSettings = lazy(() => import('@pages/Admin/PlatformSettings/PlatformSettings'))
const PlatformSettings2 = lazy(() => import('@pages/Admin/PlatformSettings2/PlatformSettings'))
const CensorshipWords = lazy(() => import('@pages/Admin/CensorshipWords'))
const ThemeEditor = lazy(() => import('@pages/Admin/ThemeEditor/Theme'))
const ThemeEditorBeta = lazy(() => import('@pages/Admin/ThemeEditor/ThemeBeta'))
const TaskBank = lazy(() => import('@pages/Admin/TaskBank'))
const Personal = lazy(() => import('@pages/Personal'))
const RatingPage = lazy(() => import('@pages/Rating'))
const CoursesPage = lazy(() => import('@pages/Courses'))
const CoursesCatalogPage = lazy(() => import('@pages/CoursesCatalog'))
const LessonPageDesignChoice = lazy(() => import('@pages/Lesson/designChoise'))
const LessonBeta = lazy(() => import('@pages/Lesson/LessonBeta'))
const Work = lazy(() => import('@pages/HomeWork/Work'))
const DzStudents = lazy(() => import('@pages/DzStudents'))
const CourseManagementPage = lazy(() => import('@pages/Admin/CourseManagementPage'))
const EditCoursePage = lazy(() => import('@pages/Admin/EditCoursePage'))
const Colloquium = lazy(() => import('@pages/Colloquium'))
const CourseSettings = lazy(() => import('@pages/Admin/CourseSettings'))
const Direction = lazy(() => import('@pages/Admin/DirectionEditor'))
const Reports = () => null
const LessonCheck = lazy(() => import('@pages/Lesson/Check'))
const HistoryPayment = lazy(() => import('@pages/HistoryPayment'))
const GiftShop = lazy(() => import('@pages/GiftShop'))
const ControlWorkEditor = lazy(() => import('@pages/Admin/ThemeEditor/ControlWork'))
const ColloquiumEditor = lazy(() => import('@pages/Admin/ThemeEditor/Colloquium'))
const Requests = lazy(() => import('@pages/Admin/Requests'))
const Helpdesk = lazy(() => import('@pages/Helpdesk'))
const NewStudents = lazy(() => import('@pages/Admin/NewStudents'))
const ManagePage = lazy(() => import('@pages/Admin/Manage'))
const ChatsPage = lazy(() => import('@pages/Chats/index'))
const AnalyticsCRMPage = lazy(() => import('@pages/Admin/AnalyticsCRMPage/AnalyticsCRMPage'))
const WksSettings = lazy(() => import('@pages/Admin/WksSettings/index'))
const ManageClassSettings = lazy(() => import('@pages/Admin/ManageClassSettings'))
const TaskBankAdd = lazy(() => import('@pages/Admin/TaskBankAdd'))
const Salary = lazy(() => import('@pages/Admin/Salary'))
const UniqueDz = lazy(() => import('@pages/UniqueDz'))
const Checking = lazy(() => import('@pages/DzStudents/Checking'))
const CheckingBeta = lazy(() => import('@pages/DzStudents/CheckingBeta'))
const AdditionalProbe = lazy(() => import('@pages/Admin/AdditionalProbe/AdditionalProbe'))
const AdditionalProbePage = lazy(() => import('@pages/AdditionalProbe'))
const Control = lazy(() => import('@pages/Control'))
const CheckingProbe = lazy(() => import('@pages/DzStudents/CheckingProbe'))
const CheckingProbeBeta = lazy(() => import('@pages/DzStudents/CheckingProbeBeta'))
const CoursesCheck = lazy(() => import('@pages/Courses/check'))
const CoursePlanCheck = lazy(() => import('@pages/CoursePlan/check'))
const CourseCheck = lazy(() => import('@pages/Course/check'))
const ProbeCheck = lazy(() => import('@pages/Probe/check'))
const ControlCheck = lazy(() => import('@pages/Control/check'))
const ColloquiumCheck = lazy(() => import('@pages/Colloquium/check'))
const CheckingControl = lazy(() => import('@pages/DzStudents/CheckingControl'))
const CheckingControlBeta = lazy(() => import('@pages/DzStudents/CheckingControlBeta'))
const LearningDynamic = lazy(() => import('@pages/LearningDynamic'))
const BlocksInDerection = lazy(() => import('@pages/Course/BlocksInDerection'))
const BlocksInDerectionBeta = lazy(() => import('@pages/Course/BlocksInDerectionBeta'))//betaBeta
const ProbesPage = lazy(() => import('@pages/Course/probes'))
const CoursePlan = lazy(() => import('@pages/CoursePlan/CoursePlan'))
const ThemesInBlocsBeta = lazy(() => import('@pages/CoursePlan/ThemesInBlocsBeta'))
const SelfEmploymentChecks = lazy(() => import('@pages/Admin/Reports/SelfEmploymentChecks'))
const BannerManagement = lazy(() => import('@pages/Admin/BannerManagement'))
const BannerManagementV2 = lazy(() => import('@pages/Admin/BannerManagementV2'))
const BannerManagementEdit = lazy(() => import('@pages/Admin/BannerManagement/Edit'))
const BannerSettings = lazy(() => import('@pages/Admin/BannerSettings'))
const Wages = lazy(() => import('@pages/Admin/Reports/Wages'))
const FinancialCountdown = lazy(() => import('@pages/Admin/Reports/FinancialCountdown'))
const TotalSalaryReport = lazy(() => import('@pages/Admin/Reports/TotalSalaryReport'))
const ReferralProgramReport = lazy(() => import('@pages/Admin/Reports/ReferralProgramReport'))
const ContinuingEducation = lazy(() => import('@pages/Admin/Reports/ContinuingEducation'))
const PromoCode = lazy(() => import('@pages/Admin/Reports/PromoCode'))
const LearningDynamics = lazy(() => import('@pages/Admin/Reports/LearningDynamics'))
const DebtorReports = lazy(() => import('@pages/Admin/Reports/DebtorReports'))
const ComfortWorking = lazy(() => import('@pages/Admin/Reports/ComfortWorking'))
const Communication = lazy(() => import('@pages/Admin/Communication'))
const DzAnalytics = lazy(() => import('@pages/Admin/Reports/DzAnalytics'))
const HomeworkStatisticsReport = lazy(() => import('@pages/Admin/Reports/HomeworkStatisticsReport'))
const IpLogReport = lazy(() => import('@pages/Admin/Reports/IpLogReport'))
const SupportTicketsReport = lazy(() => import('@pages/Admin/Reports/SupportTicketsReport'))
const ContractReport = lazy(() => import('@pages/Admin/Reports/ContractReport'))
const PlatformVisits = lazy(() => import('@pages/Admin/Reports/PlatformVisits'))
const ActivityAnalytics = lazy(() => import('@pages/Admin/Reports/ActivityAnalytics'))
const ActiveStudentLessonDynamics = lazy(() => import('@pages/Admin/Reports/ActiveStudentLessonDynamics'))
const Plums = lazy(() => import('@pages/Admin/Reports/Plums'))
const LeftStudentsReport = lazy(() => import('@pages/Admin/Reports/LeftStudentsReport'))
const SeminarAnalytics = lazy(() => import('@pages/Admin/Reports/SeminarAnalytics'))
const ForParents = lazy(() => import('@pages/Admin/Reports/ForParents'))
const ParentsReport = lazy(() => import('@pages/Admin/Reports/ParentsReport'))
const ComfortColleagues = lazy(() => import('@pages/Admin/Reports/ComfortColleagues'))
const CourseAnalyticsReport = lazy(() => import('@pages/Admin/Reports/CourseAnalytics'))
const JournalDashboards = lazy(() => import('@pages/Admin/Reports/JournalDashboards'))
const InDevelopment = lazy(() => import('@pages/InDevelopment'))
const Group = lazy(() => import('@pages/Admin/Reports/Group'))
const PrivateOwners = lazy(() => import('@pages/Admin/Reports/PrivateOwners'))
const LectureAnalytics = lazy(() => import('@pages/Admin/Reports/LectureAnalytics'))
const VideoLesson = lazy(() => import('@pages/VideoLesson'))
const ForSeminars = lazy(() => import('@pages/Admin/ForSeminars'))
const LearningBase = lazy(() => import('@pages/Admin/LearningBase'))
const InputsNewPage = lazy(() => import('@pages/Test/InputsNewPage/InputsNewPage'))
const InDevelopmentChildren = lazy(() => import('@pages/InDevelopmentChildren'))
const SwaggerUIComponent = lazy(() => import('@pages/Swagger'))
const Journal = lazy(() => import('@pages/Journal'))
const Journal2 = lazy(() => import('@pages/Journal2'))

const Test = lazy(() => import('@pages/Test'))
const Check = lazy(() => import('@pages/Admin/Check'))
const ProbeEditor = lazy(() => import('@pages/Admin/ThemeEditor/Probe'))
const Probe = lazy(() => import('@pages/Probe'))
const PaymentsReport = lazy(() => import('@pages/Admin/Reports/Payments/report'))
const HomeworkReport = lazy(() => import('@pages/Admin/Reports/HomeworkReport/index'))
const HomeworkPlanReport = lazy(() => import('@pages/Admin/Reports/HomeworkPlanReport/index'))
const PaymentsReportV2 = lazy(() => import('@pages/Admin/Reports/Payments/index'))
const MainPage = lazy(() => import('@pages/Main'))
const SopPage = lazy(() => import('@pages/SOP'))
const Payment = lazy(() => import('@pages/Payment'))
const Sop = lazy(() => import('@pages/Admin/Reports/Sop'))
const Sales = lazy(() => import('@pages/Admin/Reports/Sales'))
const Payments = lazy(() => import('@pages/Admin/Payments'))
const Library = lazy(() => import('@pages/Library'))
const EditClass = lazy(() => import('src/components/pages/Admin/NewStudents/Classes/components/EditClass'))

const Profile = lazy(() => import('@pages/Profile'))
const PlatformMedia = lazy(() => import('@pages/PlatformMedia'))

const Surveys = lazy(() => import('@pages/Admin/Surveys'))
const SurveyCreate = lazy(() => import('@pages/Admin/Surveys/Create'))
const MySurveys = lazy(() => import('@pages/MySurveys'))
const Survey = lazy(() => import('@pages/MySurveys/Components/Survey'))
const SurveyLink = lazy(() => import('@pages/MySurveys/Components/FollowingLink'))
const UserSurveyAnalytics = lazy(() => import('@pages/Admin/Surveys/Analytics/UserSurveyAnalytics'))
const SurveyAnalytics = lazy(() => import('@pages/Admin/Surveys/Analytics/SurveyAnalytics'))
const AnalyticsAnswers = lazy(() => import('@pages/Admin/Surveys/Analytics/AnalyticsAnswers'))

const NotificationsAndMailings = lazy(()=>import('@pages/Admin/NotificationsAndMailings'))
const MailingsCreate = lazy(()=>import('@pages/Admin/Mailings/Create'))
const NotificationCreate = lazy(()=>import('@pages/Admin/NotificationSettings'))

const CRM = lazy(() => import('@pages/Admin/CRM'))
const CRMSettings = lazy(() => import('@pages/Admin/CRMSettings'))
const KanbanCRMPage = lazy(() => import('@pages/Admin/KanbanCRM/KanbanCRMPage'))
const TaskTrackerCRMPage = lazy(() => import('@pages/Admin/TaskTrackerCRM/TaskTrackerCRMPage'))
const WazzupGlobalChat = lazy(() => import('@pages/WazzupGlobalChat'))

const CourseAnalytics = lazy(()=>import('@pages/Admin/CourseAnalytics'))
const LicenseAndPayment = lazy(()=>import('@pages/Admin/LicenseAndPayment'))
const UnauthorizedCatalog = lazy(()=>import('../components/pages/CoursesCatalog/tabs/UnauthorizedCatalog/UnauthorizedCatalog'))
const PurchasingCourseOrClassUsingLink = lazy(()=>import('@pages/PurchasingCourseOrClassUsingLink'))
const ProfileView = lazy(()=>import('@pages/ProfileView'))
const AdditionalActivities = lazy(()=>import('@pages/Admin/Reports/AdditionalActivities'))
const TimetablePage = lazy(() => import('@pages/Main/TimetablePage/TimetablePage'))
const AiTutor = lazy(() => import('@pages/Admin/AiTutor/AiTutor'))
const AiTutorEdit = lazy(() => import('@pages/Admin/AiTutor/AiTutorEdit'))
const AiTutorChatPage = lazy(() => import('@pages/AiTutorChat'))
const AiTutorReports = lazy(() => import('@pages/Admin/Reports/AiTutorReports'))
const AudiencesReport = lazy(() => import('@pages/Admin/Reports/Audiences'))

const restrictAccessStudents = true;

const TASK_TRACKER_ACCESS_ROLES = [
	rolesEnum.admin,
	rolesEnum.juniorAdmin,
	rolesEnum.children,
	rolesEnum.hrManager,
	rolesEnum.personalManager,
	rolesEnum.seminarian,
	rolesEnum.seniorSeminarian,
	'head-of-sales',
	'sales-manager',
];

export const previewRoutes = [
	{
		path: '/courses/all/preview-no-auth',
		exact: true,
		components: UnauthorizedCatalog,
		previewNoAuth: true
	}
];

export const routes = [
	{
		path: '/',
		pathToLabel: '/',
		exact: true,
		label: Config.PROJECT_NAME,
		components: MainPage,
	},
	{
		path: '/personal',
		pathToLabel: '/personal',
		exact: true,
		label: 'Редактирование профиля',
		components: Personal,
	},
	{
		path: '/sop-:id',
		pathToLabel: '/sop',
		exact: true,
		label: 'Система оценки преподавателей',
		components: SopPage,
	},

	{
		path: '/rating',
		pathToLabel: '/rating',
		exact: true,
		label: 'Мой рейтинг',
		components: RatingPage,
	},

	{
		path: '/learning-base',
		pathToLabel: '/learning-base',
		exact: true,
		label: 'База знаний',
		components: LearningBase,
	},
	// {
	// 	path: '/courses-catalog',
	// 	pathToLabel: '/courses-catalog',
	// 	exact: true,
	// 	label: 'Каталог курсов',
	// 	components: CoursesCatalogPage,
	// },
	{
		path: '/courses',
		pathToLabel: '/courses',
		exact: true,
		label: 'Курсы',
		components: CoursesPage,
	},
	{
		path: '/v2/courses',
		pathToLabel: '/courses',
		exact: true,
		label: 'Курсы',
		components: CoursesPage,
	},

	{
		path: ["/courses/all", "/v2/courses/my"],
		// pathToLabel: '/all',
		exact: true,
		label: 'Все курсы',
		components: CoursesCatalogPage,
	},
	{
		path: "/v2/courses/archive",
		exact: true,
		label: 'Архивные курсы',
		components: CoursesCatalogPage,
	},

	// {
	// 	path: '/courses/all',
	// 	pathToLabel: '/all',
	// 	exact: true,
	// 	label: 'Все курсы',
	// 	components: CoursesPage,
	// },

	{
		path: '/courses/my',
		pathToLabel: '/my',
		exact: true,
		label: 'Мои курсы',
		components: CoursesPage,
	},
	// {
	// 	path: '/v2/courses/my',
	// 	pathToLabel: '/my',
	// 	exact: true,
	// 	label: 'Мои курсы',
	// 	components: CoursesPage,
	// },
	// {
	// 	path: '/v2/courses/my',
	// 	pathToLabel: '/my',
	// 	exact: true,
	// 	label: 'Мои курсы',
	// 	components: CoursesCatalogPage,
	// },
	{
		path: '/courses/my/:id',
		pathToLabel: '/course',
		exact: true,
		components: BlocksInDerection,
	},
	{
		path: '/v2/courses/my/course-or-group-:courseIdOrGroupId',
		pathToLabel: '/course',
		exact: true,
		components: BlocksInDerectionBeta,
	},
	{
		path: '/courses/my/:id/no-course/probes',
		pathToLabel: '/probes',
		exact: true,
		label: 'Доп.Пробники',
		components: ProbesPage,
	},
	{
		path: '/courses/my/:id/no-course/probes-:id',
		exact: true,
		components: AdditionalProbePage,
	},

	{
		path: '/courses/my/:id/:course',
		exact: true,
		label: 'План курса',
		components: CoursePlan,
	},
	{
		path: '/v2/courses/my/course-or-group-:courseIdOrGroupId/block-:blockId',
		exact: true,
		label: 'План курса',
		components: ThemesInBlocsBeta,
	},
	{
		path: '/courses/my/:id/:course/topic-:theme',
		exact: true,
		components: LessonPageDesignChoice,
	},
	{
		path: '/v2/courses/my/course-or-group-:courseIdOrGroupId/block-:blockId/topic-:themeId',
		exact: true,
		components: LessonBeta,
	},
	{
		path: '/courses/my/:id/:course/colloquium-:theme',
		pathToLabel: '/colloquium',
		exact: true,
		label: 'Контроль знаний',
		components: Colloquium,
	},
	{
		path: '/home-work/control-:theme',
		exact: true,
		label: 'Контроль знаний',
		components: Control,
	},

	{
		path: '/home-work/probe-:theme',
		pathToLabel: '/probe',
		exact: true,
		label: 'Контроль знаний',
		components: Probe,
	},

	{
		path: '/home-work',
		pathToLabel: '/home-work',
		exact: true,
		label: 'Мои задания',
		components: HomeWorkPageContainer,
	},
	{
		path: '/home-work/learning-dynamic',
		pathToLabel: '/learning-dynamic',
		exact: true,
		label: 'Динамика обучения',
		components: restrictAccessStudents ? InDevelopment : LearningDynamic,
	},
	{
		path: '/home-work/lesson-:lessonId([0-9]+)/preview',
		exact: true,
		label: 'Просмотр заданий',
		components: Work,
	},
	{
		path: '/home-work/work-:id([0-9]+)',
		exact: true,
		label: 'Домашняя работа',
		components: Work,
	},

	{
		path: '/video-lesson',
		pathToLabel: '/video-lesson',
		exact: true,
		label: 'Запись занятий',
		components: VideoLesson,
	},

	{
		path: '/payment',
		pathToLabel: '/payment',
		exact: true,
		label: 'Оплата и скидки',
		components: Payment,
	},

	{
		path: '/payment/history',
		pathToLabel: '/history',
		exact: true,
		label: 'История списаний и зачислений',
		components: HistoryPayment,
	},

	{
		path: '/shop',
		pathToLabel: '/shop',
		exact: true,
		label: 'Магазин подарков',
		components: GiftShop,
	},

	{
		path: '/games',
		pathToLabel: '/games',
		exact: true,
		label: 'Пятиминутки и игры',
		components: restrictAccessStudents ? InDevelopment : InDevelopment,
	},

	{
		path: '/courses-check',
		pathToLabel: '/courses-check',
		exact: true,
		label: 'Доступные курсы',
		components: CoursesCheck,
		forRole: [
			rolesEnum.personalManager,
			rolesEnum.hrManager,
			rolesEnum.seminarian,
			rolesEnum.seniorSeminarian,
		],
	},

	{
		path: '/courses-check/:id',
		exact: true,
		components: CourseCheck,
		forRole: [
			rolesEnum.personalManager,
			rolesEnum.hrManager,
			rolesEnum.seminarian,
			rolesEnum.seniorSeminarian,
		],
	},

	{
		path: '/courses-check/:direction_id/:id',
		exact: true,
		components: CoursePlanCheck,
		forRole: [
			rolesEnum.personalManager,
			rolesEnum.hrManager,
			rolesEnum.seminarian,
			rolesEnum.seniorSeminarian,
		],
	},
	{
		path: '/courses-check/:direction_id/:course_id/topic-:id',
		exact: true,
		components: LessonCheck,
		forRole: [
			rolesEnum.personalManager,
			rolesEnum.hrManager,
			rolesEnum.seminarian,
			rolesEnum.seniorSeminarian,
		],
	},
	{
		path: '/courses-check/:direction_id/:course_id/probe-:id',
		exact: true,
		components: ProbeCheck,
		forRole: [
			rolesEnum.personalManager,
			rolesEnum.hrManager,
			rolesEnum.seminarian,
			rolesEnum.seniorSeminarian,
		],
	},
	{
		path: '/courses-check/:direction_id/:course_id/control-:id',
		exact: true,
		components: ControlCheck,
		forRole: [
			rolesEnum.personalManager,
			rolesEnum.hrManager,
			rolesEnum.seminarian,
			rolesEnum.seniorSeminarian,
		],
	},
	{
		path: '/courses-check/:direction_id/:course_id/colloquium-:id',
		exact: true,
		components: ColloquiumCheck,
		forRole: [
			rolesEnum.personalManager,
			rolesEnum.hrManager,
			rolesEnum.seminarian,
			rolesEnum.seniorSeminarian,
		],
	},

	{
		path: '/payments',
		pathToLabel: '/payments',
		exact: true,
		label: 'Оплаты',
		components: Payments,
		forRole: [
			rolesEnum.personalManager,
			rolesEnum.hrManager,
		],
	},

	{
		path: '/journal',
		pathToLabel: '/journal',
		exact: true,
		label: 'Электронный журнал',
		components: Journal,
		forRole: [
			rolesEnum.personalManager,
			rolesEnum.hrManager,
			rolesEnum.seminarian,
			rolesEnum.seniorSeminarian,
			rolesEnum.children,
			rolesEnum.parent,
		],
	},

	{
		path: '/v2/journal/student/:childId/:name',
		exact: true,
		label: 'Электронный журнал',
		components: Journal2,
		forRole: [
			rolesEnum.admin,
			rolesEnum.juniorAdmin,
			rolesEnum.seminarian,
			rolesEnum.seniorSeminarian
		],
	},

	{
		path: '/v2/journal',
		pathToLabel: '/v2/journal',
		exact: true,
		label: 'Электронный журнал',
		components: Journal2,
		forRole: [
			rolesEnum.personalManager,
			rolesEnum.hrManager,
			rolesEnum.seminarian,
			rolesEnum.seniorSeminarian,
			rolesEnum.children,
			rolesEnum.parent,
		],
	},

	{
		path: '/students-and-group',
		pathToLabel: '/students-and-group',
		exact: true,
		label: 'Новые ученики',
		components: () => <NewStudents allowPersonalManager={true} />,
		forRole: Config.EDITING_GROUPS_FOR_PERSONAL_MANAGER ? [rolesEnum.personalManager] : [],
	},

	{
		path: '/journal-hr',
		pathToLabel: '/journal-hr',
		exact: true,
		label: 'Журнал HR',
		components: InDevelopment,
		forRole: [
			rolesEnum.hrManager,
		],
	},
	{
		path: '/direction-editor',
		pathToLabel: '/direction-editor',
		exact: true,
		label: 'Управление курсами',
		components: CourseManagementPage,
		forRole: ['hr-manager', 'senior-seminarian', rolesEnum.seminarian, rolesEnum.franchiseManager],
	},
	{
		path: '/edit-direction/:id',
		exact: true,
		label: 'Редактирование курса',
		components: EditCoursePage,
		forRole: ['hr-manager', 'senior-seminarian', rolesEnum.seminarian],
	},
	// {
	// 	path: '/direction-editor/direction-:id/:filterId?',
	// 	exact: true,
	// 	components: Direction,
	// 	forRole: ['hr-manager', 'senior-seminarian'],
	// 	noMobile: true,
	// },
	{
		path: '/direction-editor/direction-:id/:filterId?',
		exact: true,
		components: CourseSettings,
		forRole: ['hr-manager', 'senior-seminarian', rolesEnum.franchiseManager],
	},
	{
		path: '/direction-editor/theme-:topicId',
		exact: true,
		components: ThemeEditor,
		forRole: ['hr-manager', 'senior-seminarian', rolesEnum.seminarian],
		noMobile: true,
	},
	{
		path: '/v2/direction-editor/theme-:topicId',
		exact: true,
		components: ThemeEditorBeta,
		forRole: ['hr-manager', 'senior-seminarian', rolesEnum.seminarian],
		noMobile: true,
	},

	{
		path: '/direction-editor/control-:id',
		exact: true,
		components: ControlWorkEditor,
		forRole: ['hr-manager', 'senior-seminarian', rolesEnum.seminarian],
		noMobile: true,
	},
	{
		path: '/direction-editor/probe-:id',
		exact: true,
		components: ProbeEditor,
		forRole: ['hr-manager', 'senior-seminarian', rolesEnum.seminarian],
		noMobile: true,
	},
	{
		path: '/direction-editor/colloquium-:id',
		exact: true,
		components: ColloquiumEditor,
		forRole: ['hr-manager', 'senior-seminarian', rolesEnum.seminarian],
		noMobile: true,
	},

	// {
	// 	path: '/admin/banner-management',
	// 	pathToLabel: '/banner-management',
	// 	exact: true,
	// 	label: 'Управление баннерами',
	// 	components: BannerManagement,
	// 	forRole: ['hr-manager'],
	// 	noMobile: true,
	// },
	{
		path: '/admin/banner-management',
		exact: true,
		label: 'Управление баннерами',
		components: BannerManagementV2,
		forRole: ['hr-manager', rolesEnum.franchiseManager],
	},
	// {
	// 	path: '/admin/banner-management/create',
	// 	exact: true,
	// 	label: 'Управление баннерами',
	// 	components: BannerManagementEdit,
	// 	forRole: ['hr-manager'],
	// 	noMobile: true,
	// },
	// {
	// 	path: '/admin/banner-management/:id',
	// 	exact: true,
	// 	label: 'Управление баннерами',
	// 	components: BannerManagementEdit,
	// 	forRole: ['hr-manager'],
	// 	noMobile: true,
	// },
	{
		path: '/banner-settings/:id?',
		exact: true,
		label: 'Редактирование баннера',
		components: BannerSettings,
		forRole: ['hr-manager', rolesEnum.franchiseManager],
	},
	// {
	// 	path: '/admin/banner-management/create',
	// 	exact: true,
	// 	label: 'Управление баннерами',
	// 	components: BannerManagementEdit,
	// 	forRole: ['hr-manager'],
	// 	noMobile: true,
	// },
	{
		path: '/users',
		pathToLabel: '/users',
		label: 'Пользователи',
		exact: true,
		components: UsersRedirect,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'head-of-sales',
			'sales-manager'
		],
	},

	{
		path: '/users/parents',
		pathToLabel: '/parents',
		exact: true,
		label: 'Родители',
		components: Parents,
		forRole: ['personal-manager', 'hr-manager', 'senior-seminarian', 'sales-manager', 'franchise-manager'],
	},

	{
		path: '/users/colleges',
		pathToLabel: '/colleges',
		exact: true,
		label: 'Коллеги',
		components: CollegesPage,
		forRole: [
			'hr-manager',
			'senior-seminarian',
			'head-of-sales',
			rolesEnum.franchiseManager,
		],
	},

	{
		path: '/users/students',
		pathToLabel: '/students',
		exact: true,
		label: 'Ученики',
		components: StudentsPage,
		forRole: ['personal-manager', 'seminarian', 'senior-seminarian', 'sales-manager'],
	},

	{
		path: '/requests',
		pathToLabel: '/requests',
		exact: true,
		label: 'Запросы',
		components: Requests,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'children'
		],
	},

	{
		path: '/helpdesk',
		pathToLabel: '/helpdesk',
		exact: true,
		label: 'Helpdesk',
		components: Helpdesk,
		forRole: [
			rolesEnum.admin,
			rolesEnum.juniorAdmin,
			rolesEnum.personalManager,
			rolesEnum.hrManager,
			rolesEnum.seminarian,
			rolesEnum.seniorSeminarian,
			'head-of-sales',
			'sales-manager',
		],
	},
	{
		path: '/salary',
		pathToLabel: '/salary',
		exact: true,
		label: 'Зарплата',
		components: Salary,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'other',
		],
	},

	{
		path: '/new-students',
		pathToLabel: '/new-students',
		exact: true,
		label: 'Новые ученики',
		components: NewStudents,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
			'head-of-sales',
		],
	},
	{
		path: '/manage',
		pathToLabel: '/manage',
		exact: true,
		components: ManagePage,
		forRole: [
			'personal-manager',
			'senior-seminarian',
		],
	},
	{
		path: '/manage/:type', // type = 'students' | 'groups' | 'classes'
		pathToLabel: '/manage/:type',
		exact: true,
		components: ManagePage,
		forRole: [
			'personal-manager',
			'senior-seminarian',
			'seminarian'
		],
	},
	{
		path: '/manage/classes/settings/:id',
		pathToLabel: '/manage/classes/settings/:id',
		exact: true,
		components: ManageClassSettings,
		forRole: [],
	},
	{
		path: '/communication',
		pathToLabel: '/communication',
		exact: true,
		label: 'Общение',
		components: Communication,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
		],
	},

	{
		path: '/reports',
		pathToLabel: '/reports',
		exact: false,
		label: 'Отчеты',
		components: Reports,
		noMobile: true,
	},
	{
		path: '/reports/audiences',
		pathToLabel: '/audiences',
		exact: true,
		label: 'Кабинеты/Аудитории',
		components: AudiencesReport,
		forRole: [rolesEnum.admin, rolesEnum.juniorAdmin],
		noMobile: true,
	},
	{
		path: '/reports/course-analytics',
		pathToLabel: '/course-analytics',
		exact: true,
		label: 'Аналитика по курсу',
		components: CourseAnalyticsReport,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
			'children',
			'parent',
		],
		noMobile: true,
	},
	{
		path: '/reports/journal-dashboards',
		pathToLabel: '/journal-dashboards',
		exact: true,
		label: 'Дашборды из Элжура',
		components: JournalDashboards,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/group',
		pathToLabel: '/group',
		exact: true,
		label: 'По группе',
		components: Group,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},

	{
		path: '/reports/group-reports',
		pathToLabel: '/group-reports',
		exact: true,
		label: 'Группы',
		components: GroupWrap,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/group-lesson',
		pathToLabel: '/group-lesson',
		exact: true,
		label: 'Группы',
		components: GroupLessonReport,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/group-lesson-payment',
		pathToLabel: '/group-lesson-payment',
		exact: true,
		label: 'Групповые. Оплата по занятиям',
		components: GroupLessonpaymentReport,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/private-lesson',
		pathToLabel: '/private-lesson',
		exact: true,
		label: 'Частные',
		components: PrivateLessonReport,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/introductory-lesson',
		pathToLabel: '/introductory-lesson',
		exact: true,
		label: 'Вводные уроки',
		components: IntroductoryLessonReport,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
			'head-of-sales',
		],
		noMobile: true,
	},
	{
		path: '/reports/chats-statistics',
		pathToLabel: '/chats-statistics',
		exact: true,
		label: 'Статистика чатов',
		components: ChatsStatisticsReport,
		noMobile: true,
	},
	{
		path: '/reports/user-rating',
		pathToLabel: '/user-rating',
		exact: true,
		label: 'Рейтинг учащихся',
		components: UserRatingReport,
	},
	{
		path: '/reports/certificates',
		pathToLabel: '/certificates',
		exact: true,
		label: 'Отчет по сертификатам',
		components: CertificatesReport,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},

	{
		path: '/reports/group-overview',
		pathToLabel: '/group-overview',
		exact: true,
		label: 'По группе',
		components: Overview,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},

	{
		path: '/reports/private-owners',
		pathToLabel: '/private-owners',
		exact: true,
		label: 'По частникам',
		components: PrivateOwners,
		noMobile: true,
	},
	{
		path: '/reports/lecture-analytics',
		pathToLabel: '/lecture-analytics',
		exact: true,
		label: 'Аналитика лекций',
		components: LectureAnalytics,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/seminar-analytics',
		pathToLabel: '/seminar-analytics',
		exact: true,
		label: 'Аналитика семинаров',
		components: SeminarAnalytics,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/dz-analytics',
		pathToLabel: '/dz-analytics',
		exact: true,
		label: 'Аналитика дз',
		components: DzAnalytics,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/homework-statistics/students',
		pathToLabel: '/homework-statistics/students',
		exact: true,
		label: 'Аналитика ДЗ: Выполняемость работ',
		components: HomeworkStatisticsReport,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/additional-activities',
		pathToLabel: '/additional-activities',
		exact: true,
		label: 'Аналитика дополнительных занятий',
		components: AdditionalActivities,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/homework-statistics/seminarians',
		pathToLabel: '/homework-statistics/seminarians',
		exact: true,
		label: 'Аналитика ДЗ: Отчет по проверкам',
		components: HomeworkStatisticsReport,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/ip-log',
		pathToLabel: '/ip-log',
		exact: true,
		label: 'Отчет по IP пользователей',
		components: IpLogReport,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/support-tickets',
		pathToLabel: '/support-tickets',
		exact: true,
		label: 'SLA. Техподдержка',
		components: SupportTicketsReport,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/contract-report',
		pathToLabel: '/contract-report',
		exact: true,
		label: 'Договоры',
		components: ContractReport,
		forRole: ['admin', 'junior-admin'],
		noMobile: true,
	},
	{
		path: '/reports/platform-visits',
		pathToLabel: '/platform-visits',
		exact: true,
		label: 'Посещения платформы',
		components: PlatformVisits,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/activity-analytics',
		pathToLabel: '/activity-analytics',
		exact: true,
		label: 'Аналитика активности',
		components: ActivityAnalytics,
		forRole: [
			'admin',
			'junior-admin',
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/active-student-lesson-dynamics',
		pathToLabel: '/active-student-lesson-dynamics',
		exact: true,
		label: 'Динамика занятий активных учащихся',
		components: ActiveStudentLessonDynamics,
		forRole: [
			'admin',
			'junior-admin',
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/plums',
		pathToLabel: '/plums',
		exact: true,
		label: 'По сливам',
		components: Plums,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/left-students-report',
		pathToLabel: '/left-students-report',
		exact: true,
		label: 'По сливам',
		components: LeftStudentsReport,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/for-parents',
		pathToLabel: '/for-parents',
		exact: true,
		label: 'Отчет для родителей',
		components: ForParents,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/parents',
		pathToLabel: '/parents',
		exact: true,
		label: 'Отчет для родителей',
		components: ParentsReport,
		forRole: [
			'admin',
			'junior-admin',
			'parent',
			'children',
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/comfort-colleagues',
		pathToLabel: '/comfort-colleagues',
		exact: true,
		label: 'Комфорт коллег',
		components: ComfortColleagues,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/sop',
		pathToLabel: '/sop',
		exact: true,
		label: 'СОП учеников',
		components: Sop,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/sales',
		pathToLabel: '/sales',
		exact: true,
		label: 'По продажам',
		components: Sales,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/self-employment-checks',
		pathToLabel: '/self-employment-checks',
		exact: true,
		label: 'По чекам самозанятых',
		components: SelfEmploymentChecks,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/wages',
		pathToLabel: '/wages',
		exact: true,
		label: 'По ЗП',
		components: Wages,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/financial-countdown',
		pathToLabel: '/financial-countdown',
		exact: true,
		label: 'Финансовый отчет',
		components: FinancialCountdown,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/total-salary',
		pathToLabel: '/total-salary',
		exact: true,
		label: 'Отчёт по общей зарплате',
		components: TotalSalaryReport,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/referral-program',
		pathToLabel: '/referral-program',
		exact: true,
		label: 'Отчет по реф. программе',
		components: ReferralProgramReport,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
			'head-of-sales',
			'other',
		],
		noMobile: true,
	},
	{
		path: '/reports/continuing-education',
		pathToLabel: '/continuing-education',
		exact: true,
		label: 'Продление обучения',
		components: ContinuingEducation,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/promo-code',
		pathToLabel: '/promo-code',
		exact: true,
		label: 'По промокодам',
		components: PromoCode,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/learning-dynamics',
		pathToLabel: '/learning-dynamics',
		exact: true,
		label: 'Отчет динамики обучения',
		components: LearningDynamics,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/debtor-payment',
		pathToLabel: '/debtor-payment',
		exact: true,
		label: 'Задолженности по оплатам и отсрочки',
		components: DebtorReports,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
	},
	{
		path: '/reports/comfort-working',
		pathToLabel: '/comfort-working',
		exact: true,
		label: 'Комфорт работы',
		components: ComfortWorking,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/payments',
		pathToLabel: '/payments',
		exact: true,
		label: 'Оплаты',
		components: PaymentsReport,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/homework',
		pathToLabel: '/homework',
		exact: true,
		label: 'Аналитика Д/З',
		components: HomeworkReport,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/homework-plan',
		pathToLabel: '/homework-plan',
		exact: true,
		label: 'Задавание Д/З: план-факт',
		components: HomeworkPlanReport,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/paymentsV2',
		pathToLabel: '/payments',
		exact: true,
		label: 'Оплаты',
		components: PaymentsReportV2,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/reports/ai-tutor',
		pathToLabel: '/ai-tutor',
		exact: true,
		label: 'Статистика ИИ тьюторов',
		components: AiTutorReports,
		forRole: [
			rolesEnum.admin,
			rolesEnum.juniorAdmin,
			rolesEnum.seminarian,
			rolesEnum.seniorSeminarian,
		],
		noMobile: true,
	},

	{
		path: '/unique-dz',
		pathToLabel: '/unique-dz',
		exact: true,
		label: 'Сформировать уникальное ДЗ',
		components: UniqueDz,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
		]
	},
	{
		path: '/dz-students',
		pathToLabel: '/dz-students',
		exact: true,
		label: 'Домашнее задание учеников',
		components: DzStudents,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
		],
		// noMobile: true,
	},
	{
		path: '/dz-students/:type',
		exact: true,
		label: 'Домашняя работа учеников',
		components: DzStudents,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
		],
		// noMobile: true,
	},
	{
		path: '/dz-students/checking/:id',
		exact: true,
		label: 'Домашняя работа учеников',
		components: CheckingBeta,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
		],
		// noMobile: true,
	},
	{
		path: '/dz-students/checking-beta/:id',
		exact: true,
		label: 'Домашняя работа учеников',
		components: CheckingBeta,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
		],
	},
	{
		path: '/dz-students/checkingProbe/:id',
		exact: true,
		label: 'Пробники учеников',
		components: CheckingProbeBeta,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
		],
		// noMobile: true,
	},
	{
		path: '/dz-students/CheckingProbeBeta/:id',
		exact: true,
		label: 'Пробники учеников',
		components: CheckingProbeBeta,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
		],
		// noMobile: true,
	},
	{
		path: '/dz-students/checkingControl/:id',
		exact: true,
		label: 'Контрольные учеников',
		components: CheckingControlBeta,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
		],
		// noMobile: true,
	},
	{
		path: '/dz-students/checkingControlBeta/:id',
		exact: true,
		label: 'Контрольные учеников',
		components: CheckingControlBeta,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
		],
	},
	{
		path: '/dz-colleagues',
		pathToLabel: '/dz-colleagues',
		exact: true,
		label: 'Домашнее задание коллег',
		components: InDevelopment,
		// components: DZColleges,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
	},

	{
		path: '/task-bank',
		pathToLabel: '/task-bank',
		exact: true,
		label: 'Банк и архив задач',
		components: TaskBank,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
		],
	},

	{
		path: '/task-bank/:id',
		pathToLabel: '/task-bank',
		exact: true,
		label: 'Банк и архив задач',
		components: TaskBankAdd,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
		],
	},

	{
		path: '/additional-probe',
		pathToLabel: '/additional-probe',
		exact: true,
		label: 'Дополнительный пробник',
		components: AdditionalProbe,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},
	{
		path: '/additional-probe/:id&:directionId',
		exact: true,
		label: 'Добавить дополнительный пробник',
		components: AdditionalProbeEdit,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
			'sales-manager',
		],
		noMobile: true,
	},

	{
		path: '/advertisement',
		pathToLabel: '/advertisement',
		exact: true,
		label: 'Рассылка/Реклама',
		components: InDevelopment,
		forRole: ['personal-manager', 'hr-manager'],
	},
	{
		path: '/for-seminars',
		pathToLabel: '/for-seminars',
		exact: true,
		label: 'Для семинаров',
		components: ForSeminars,
		forRole: ['seminarian', 'senior-seminarian'],
	},
	{
		path: '/check',
		pathToLabel: '/check',
		exact: true,
		label: 'Просмотр работ',
		components: Check,
		forRole: [
			'seminarian',
			'senior-seminarian',
			'personal-manager',
			'hr-manager',
		],
	},

	{
		path: '/no-access',
		pathToLabel: '/no-access',
		exact: true,
		label: 'Нет доступа',
		components: InDevelopmentChildren,
	},

	{
		path: '/test',
		pathToLabel: '/test',
		exact: true,
		label: 'Тестовая страница',
		components: Test,
	},
	{
		path: '/test/inputs',
		pathToLabel: '/inputs',
		exact: true,
		label: 'Демонстрация полей ввода',
		components: InputsNewPage,
	},
	{
		path: '/platform-settings',
		exact: true,
		label: 'Настройки платформы',
		components: PlatformSettings,
		forRole: [
			rolesEnum.admin,
			rolesEnum.juniorAdmin,
		],
	},
	{
		path: '/ai-tutors',
		exact: true,
		label: 'Конструктор ИИ тьюторов',
		components: AiTutor,
		forRole: [
			rolesEnum.admin,
			rolesEnum.juniorAdmin,
			rolesEnum.seniorSeminarian,
			rolesEnum.seminarian,
		],
	},
	{
		path: '/ai-tutors/add',
		exact: true,
		label: 'Добавить ИИ тьютора',
		components: AiTutorEdit,
		forRole: [
			rolesEnum.admin,
			rolesEnum.juniorAdmin,
			rolesEnum.seniorSeminarian,
		],
	},
	{
		path: '/ai-tutors/:id(\\d+)',
		exact: true,
		label: 'Редактирование ИИ тьютора',
		components: AiTutorEdit,
		forRole: [
			rolesEnum.admin,
			rolesEnum.juniorAdmin,
			rolesEnum.seniorSeminarian,
		],
	},
	{
		path: '/ai-tutor/:id(\\d+)',
		exact: true,
		label: 'Чат с ИИ тьютором',
		components: AiTutorChatPage,
		forRole: [
			rolesEnum.admin,
			rolesEnum.juniorAdmin,
			rolesEnum.children,
			rolesEnum.parent,
		],
	},
	{
		path: '/v2/platform-settings',
		exact: true,
		label: 'Настройки платформы',
		components: PlatformSettings2,
		forRole: [
			'admin',
			'junior-admin',
		],
	},
	{
		path: '/admin/censorship-words',
		exact: true,
		label: 'Словарь цензуры',
		components: CensorshipWords,
		forRole: [
			'admin',
			'junior-admin',
		],
	},
	// {
	// 	path: '/ai-tutors',
	// 	exact: true,
	// 	label: 'Конструктор ИИ тьюторов',
	// 	components: AiTutor,
	// 	forRole: [
	// 		'admin',
	// 		'junior-admin',
	// 	],
	// },
	// {
	// 	path: '/ai-tutors/add',
	// 	exact: true,
	// 	label: 'Добавить ИИ тьютора',
	// 	components: AiTutorEdit,
	// 	forRole: [
	// 		'admin',
	// 		'junior-admin',
	// 	],
	// },
	// {
	// 	path: '/ai-tutors/:id',
	// 	exact: true,
	// 	label: 'Редактирование ИИ тьютора',
	// 	components: AiTutorEdit,
	// 	forRole: [
	// 		'admin',
	// 		'junior-admin',
	// 	],
	// },
	{
		path: '/preview-lesson',
		exact: true,
		label: 'Предпросмотр урока',
		components: PreviewLesson,
		forRole: [
			'admin',
			'junior-admin',
			'seminarian',
			'senior-seminarian'
		],
	},
	{
		path: '/swagger',
		exact: true,
		label: 'Impulse API',
		components: SwaggerUIComponent,
		forRole: [
			'admin',
			'junior-admin',
		],
	},
	{
		path: '/news',
		exact: true,
		label: 'Новости',
		components: News,
		forRole: Object.values(rolesEnum),
	},
	{
		path: '/news/:id',
		exact: true,
		label: 'Новость',
		components: WrapperNewsViewing,
		forRole: Object.values(rolesEnum),
	},
	{
		path: '/departments',
		exact: true,
		label: 'Отделы',
		components: Departments,
		// forRole: [
		// 	'seminarian',
		// 	'senior-seminarian',
		// 	'personal-manager',
		// 	'hr-manager',
		// 	'children'
		// ],
	},
	{
		path: '/teams',
		exact: true,
		label: 'Команды',
		components: Teams,
	},
	{
		path: '/library',
		exact: true,
		label: 'Конфлюенс',
		components: Library,
		forRole: [
			'seminarian',
			'senior-seminarian',
			'personal-manager',
			'hr-manager',
			'children',
			'sales-manager',
			'head-of-sales',
			'parent',
		],
	},
	{
		path: '/library-two',
		exact: true,
		label: 'Конфлюенс',
		components: Library,
		forRole: [
			'seminarian',
			'senior-seminarian',
			'personal-manager',
			'hr-manager',
			'children',
			'sales-manager',
			'head-of-sales'
		],
	},

	{
		path: '/new-students/edit-class',
		pathToLabel: '/new-students/edit-class',
		exact: true,
		label: 'Новые классы',
		components: EditClass,
		forRole: [
			'personal-manager',
			'hr-manager',
			'seminarian',
			'senior-seminarian',
		],
	},
	{
		path: '/profile',
		exact: true,
		label: 'Мой профиль',
		components: Profile,
		forRole: [
			'children',
			'parent',
		],
	},
	{
		path: '/platform-media',
		exact: true,
		label: 'Материалы',
		components: PlatformMedia,
		forRole: [
			'seminarian',
			'senior-seminarian',
			'personal-manager',
			'hr-manager',
		],
	},
	{
		path: '/surveys',
		exact: true,
		label: 'Опросы',
		components: Surveys,
		forRole: [],
	},
	{
		path: '/survey-create/:id',
		exact: true,
		label: 'Редактировать опрос',
		components: SurveyCreate,
		orRole: [],
	},
	{
		path: '/surveys-analytics/users',
		exact: true,
		label: 'Аналитика по учащимся',
		components: UserSurveyAnalytics,
		orRole: [],
	},
	{
		path: '/survey-analytics/:id',
		exact: true,
		label: 'Аналитика',
		components: SurveyAnalytics,
		orRole: [],
	},
	{
		path: '/surveys-analytics/answers/:id',
		exact: true,
		label: 'Таблица ответов',
		components: AnalyticsAnswers,
		orRole: [],
	},
	{
		path: '/my-surveys',
		exact: true,
		label: 'Опросы',
		components: MySurveys
	},
	{
		path: '/my-survey/:id',
		exact: true,
		components: Survey,
	},
	{
		path: '/my-survey-link/:id',
		exact: true,
		components: SurveyLink,
	},
	{
		path: '/my-survey-view/:id',
		exact: true,
		components: Survey,
	},
	// {
	// 	path: '/admin/mailings',
	// 	pathToLabel: '/mailings',
	// 	exact: true,
	// 	label: 'Рассылки',
	// 	components: Mailings,
	// },
	// {
	// 	path: '/admin/mailings/:id',
	// 	pathToLabel: '/mailing',
	// 	exact: true,
	// 	label: 'Рассылка',
	// 	components: MailingsCreate,
	// },
	{
		path: '/notifi',
		exact: true,
		label: 'Уведомления и Рассылки',
		components: NotificationsAndMailings,
	},
	{
		path: '/notifi/:type', // type = 'notifications' | 'mailings'
		exact: true,
		label: 'Уведомления и Рассылки',
		components: NotificationsAndMailings,
	},
	{
		path: '/notifi/mailing/:id',
		exact: true,
		label: 'Рассылка',
		components: MailingsCreate,
	},
		{
		path: '/notifi/notification/:id',
		exact: true,
		label: 'Уведомление',
		components: NotificationCreate,
	},
	{
		path: '/crm',
		exact: true,
		label: 'CRM',
		components: CRM,
		forRole: ['admin', 'junior-admin', 'head-of-sales', 'sales-manager', 'franchise-manager'],
	},
	{
		path: '/crm-settings',
		exact: true,
		label: 'Настройки CRM',
		components: CRMSettings,
		forRole: ['admin', 'junior-admin', 'head-of-sales', 'franchise-manager'],
	},
	{
		path: '/wazzup-chats',
		exact: true,
		label: 'Wazzup Чаты',
		components: () => <WazzupGlobalChat type="whatsapp" />,
	},
	{
		path: '/wazzup-telegram',
		exact: true,
		label: 'Wazzup Telegram',
		components: () => <WazzupGlobalChat type="telegram" />,
	},
	{
		path: '/crm-analytics',
		exact: true,
		label: 'Аналитика CRM',
		components: AnalyticsCRMPage,
		forRole: ['admin', 'junior-admin', 'head-of-sales', 'sales-manager', 'franchise-manager'],
	},
	{
		path: '/task-tracker',
		exact: true,
		label: 'Task Tracker',
		components: TaskTrackerCRMPage,
		forRole: TASK_TRACKER_ACCESS_ROLES,
	},
	{
		path: '/course-analytics/:id',
		exact: true,
		components: CourseAnalytics,
		forRole: ['admin', 'junior-admin', 'hr-manager', 'senior-seminarian'],
	},
	{
		path: '/license-and-payment',
		exact: true,
		label: 'Лицензия и оплаты',
		components: LicenseAndPayment,
		forRole: ['admin', 'junior-admin'],
	},
	{
		path: '/payment-form',
		exact: true,
		label: 'Оплата',
		components: PaymentForm,
	},
	{
		path: '/purchasing-course-or-class-using-link',
		exact: true,
		label: 'Покупка курса или класса',
		components: PurchasingCourseOrClassUsingLink,
	},
	{
		path: '/profile-view',
		exact: true,
		label: 'Профиль пользователя',
		components: ProfileView,
	},
	{
		path: PATHS_BY_KEY.crmKanban,
		exact: true,
		label: 'Kanban CRM',
		components: KanbanCRMPage,
		forRole: ['admin', 'head-of-sales', 'sales-manager'],
	},
	{
		path: '/chats',
		exact: true,
		components: ChatsPage,
	},
	{
		path: PATHS_BY_KEY.timetable,
		exact: true,
		label: 'Расписание',
		components: TimetablePage,
	},
	{
		path: '/wks-settings/:type', // type = 'Automatize' | 'CreateAdress'
		pathToLabel: '/wks-settings/:type',
		exact: true,
		components: WksSettings,
		forRole: [
			'junior-admin',
			'admin',
			'seminarian'
		],
	}
	// {
	// 	path: '/manage/:type', // type = 'students' | 'groups' | 'classes'
	// 	pathToLabel: '/manage/:type',
	// 	exact: true,
	// 	components: ManagePage,
	// 	forRole: [
	// 		'personal-manager',
	// 		'senior-seminarian',
	// 		'seminarian'
	// 	],
	// },
];
